// ## Mutations ##//

import { graphql } from '@/generated/gql'

const DISCONNECT_APP =
    graphql(`mutation disconnectApp($input: DisconnectAppInput!) {
  disconnectApp(input: $input)
}`)

const UPDATE_CALENDARS =
    graphql(`mutation updateCalendars($input: UpdateCalendarsInput!) {
  updateCalendars(input: $input)
}`)

const SUBSCRIBE_INTEGRATION_INSTALLED = graphql(`
    subscription SubscribeIntegrationInstalled {
        integrationInstalled {
            installedApp
            userId
        }
    }
`)

const SYNC_EXCHANGE_CALENDAR = graphql(`
    mutation SyncExchangeCalendar{
        connectToExchangeServiceAccount {
            success
        }
    }
`)

const GET_ENABLED_CALENDARS = graphql(`
    query GetEnabledCalendars {
        appDirectory {
            enabledCalendars {
                id
                name
            }
        }
    }
`)

export {
    DISCONNECT_APP,
    UPDATE_CALENDARS,
    SUBSCRIBE_INTEGRATION_INSTALLED,
    SYNC_EXCHANGE_CALENDAR,
    GET_ENABLED_CALENDARS,
}
